import * as React from 'react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'
import type { Metadata } from 'modules/universal_importer/components/NuvoImporter/types'

type Props = {
  employeeIds: number[]
  legalEntityId?: number
  onClose: () => void
}

const TerminationImporterModal = ({ employeeIds, legalEntityId, onClose }: Props) => {
  const {
    company,
    access: { locale },
  } = useCurrentSession()

  const metadata = React.useMemo<Metadata>(
    () => ({
      employee_ids: employeeIds,
      ...(legalEntityId ? { legal_entity_ids: [legalEntityId] } : {}),
    }),
    [employeeIds, legalEntityId]
  )

  return (
    <NuvoImporter
      importType="employee_bulk_termination_importer"
      locale={locale}
      companyId={company.id}
      metadata={metadata}
      isEdition
      onCompleted={onClose}
      onError={() => {}}
    />
  )
}

export default TerminationImporterModal
